import { apiClient } from './axios';

import type { AvailabilityLeadQuery, CallWithContact, PaginatedResponse } from '@repo/shared-types';

export const availabilityLeadsApi = {
  getAvailabilityLeads: async (
    query?: Partial<AvailabilityLeadQuery>,
  ): Promise<PaginatedResponse<CallWithContact>> => {
    const response = await apiClient.get<PaginatedResponse<CallWithContact>>(
      '/availability-leads',
      { params: query },
    );
    return response.data;
  },
};
